<template>
    <div
        ref="editBookkeepingAccountPopup"
        class="fixed w-screen h-screen top-0 left-0 bg-black/60 z-20 flex items-center justify-center cursor-pointer"
        @keydown.esc="hide"
        @click.self.exact="hide"
    >
        <div class="rounded bg-base-100 shadow-lg cursor-auto flex flex-col w-[50em] p-3">
            <div class="text-xl mb-6">Endre konto</div>
            <bookkeeping-account-editor
                class="flex flex-col"
                :bookkeeping-account="props.account"
                :disable-teleport="true"
                @save="save"
                @cancel="hide"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import BookkeepingAccountEditor from '@/bookkeeping-account/BookkeepingAccountEditor.vue'
import hotkeys from 'hotkeys-js'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'
import {ref} from 'vue'
import {notifySuccess} from '@/services/infrastructure/notification.service'

const editBookkeepingAccountPopup = ref<HTMLElement | null>(null)
const emit = defineEmits(['updated', 'close'])
const hide = () => {
    emit('close')
}

const props = defineProps({
    account: {
        type: Object as () => BookkeepingAccount,
        required: true
    }
})

hotkeys('esc', hide)
const save = (account: BookkeepingAccount) => {
    emit('updated', account)
    hide()
    notifySuccess({title: 'Oppdatert', description: `Kontoen ${account.accountNo}:${account.name} ble oppdatert.`})
}

</script>

<style scoped></style>